// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.annotation_container[data-v-051d19d2]{max-height:75vh}`, "",{"version":3,"sources":["webpack://./src/components/calendar/CalendarAnnotation.vue"],"names":[],"mappings":"AACA,uCACE,eAAA","sourcesContent":["\n.annotation_container {\n  max-height: 75vh;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
